"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _breakpoints = _interopRequireDefault(require("../../components/breakpoints"));
var _default = exports.default = {
  Divider: _styledComponents.default.div`
    width: calc(100% - 40px);
    box-sizing: border-box;
    height: ${function (_ref) {
    let {
      $hideLine
    } = _ref;
    return $hideLine ? "0" : "1px";
  }};
    max-width: 1320px;
    display: block;
    overflow: hidden;
    margin: auto;
    background-color: #efefef;
    margin: auto;
    ${function (_ref2) {
    let {
      $hideLine
    } = _ref2;
    return $hideLine && `
      height: 0;
      display: inline-block;
      vertical-align: bottom;
      `;
  }}
  `,
  DividerContainer: _styledComponents.default.div`
    ${function (_ref3) {
    let {
      $spacing,
      $enableDesignTab
    } = _ref3;
    return !$enableDesignTab && ($spacing === "text" && `padding: 20px 0;
        ${(0, _breakpoints.default)("tablet", "up")} {
          padding: 25px 0;
        }` || $spacing === "block" && `padding: 40px 0;
        ${(0, _breakpoints.default)("tablet", "up")} {
          padding: 50px 0;
        }` || $spacing === "none" && "padding: 0;");
  }}
  `
};